export const packages = [
  { count: 1, price: '0' },
  { count: 2, price: '490' },
  { count: 5, price: '890' },
  { count: 15, price: '2250' },
];
export function today(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Moscow',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const part = key => parts.find(item => item.type === key).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}
export function endDate(start, days) {
  const date = new Date(`${start}T12:00:00Z`);
  if (!Number.isFinite(date.getTime())) return '';
  date.setUTCDate(date.getUTCDate() + days - 1);
  return date.toISOString().slice(0, 10);
}
export function emptyForm() {
  return {
    group: '',
    username: '',
    userId: '',
    from: today(),
    to: '',
    limit: '',
    amount: '',
    paymentDate: today(),
    notes: '',
  };
}
// Normalize only on submission: typing and pasted text stay untouched.
export function normalizeUsername(value) {
  const raw = value.trim();
  if (!raw) return '';
  const invalid = () => {
    throw new Error(
      'Укажите username или ссылку на профиль Telegram. Ссылки-приглашения и ссылки на сообщения не подходят.'
    );
  };
  let name = raw;
  if (/^@?[a-z0-9_]{1,32}$/i.test(raw)) {
    name = raw.replace(/^@/, '');
  } else {
    let url;
    try {
      url = new URL(
        /^(?:www\.)?(?:t\.me|telegram\.me|telegram\.dog)\//i.test(raw)
          ? `https://${raw}`
          : raw
      );
    } catch {
      return invalid();
    }
    if (url.username || url.password || url.port) return invalid();
    if (url.protocol === 'tg:' && url.hostname === 'resolve') {
      if (url.pathname && url.pathname !== '/') return invalid();
      if (
        [...url.searchParams.keys()].some(key => key !== 'domain') ||
        url.searchParams.getAll('domain').length !== 1
      )
        return invalid();
      name = url.searchParams.get('domain');
    } else if (
      ['https:', 'http:'].includes(url.protocol) &&
      /^(?:www\.)?(?:t\.me|telegram\.me|telegram\.dog)$/.test(url.hostname)
    ) {
      const match = url.pathname.match(/^\/([a-z0-9_]{1,32})\/?$/i);
      if (!match) return invalid();
      name = match[1];
      if (
        /^(?:joinchat|share|addlist|addstickers|addemoji|proxy|socks|login|confirmphone|setlanguage|iv|c|s|boost)$/i.test(
          name
        )
      )
        return invalid();
    } else {
      return invalid();
    }
  }
  if (!/^[a-z0-9_]{1,32}$/i.test(name)) return invalid();
  return name.toLowerCase();
}
export function validPaymentDate(value) {
  return (
    typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    value >= '2000-01-01' &&
    value <= '2100-12-31' &&
    endDate(value, 1) === value
  );
}

export function payload(form) {
  const username = normalizeUsername(form.username);
  const id = form.userId.trim();
  if (!form.group) throw new Error('Выберите группу.');
  if (!username && !id)
    throw new Error(
      'Укажите @username или TG User ID. Можно заполнить оба поля.'
    );
  if (username && !/^[a-z0-9_]{1,32}$/.test(username))
    throw new Error(
      'Проверьте @username: допустимы латинские буквы, цифры и подчёркивание, до 32 символов.'
    );
  if (
    id &&
    (!/^[1-9]\d*$/.test(id) ||
      !Number.isSafeInteger(Number(id)) ||
      Number(id) > 4503599627370495)
  )
    throw new Error('TG User ID должен быть целым положительным числом.');
  [form.from, form.to].forEach(date => {
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(date) ||
      date < '2000-01-01' ||
      date > '2100-12-31' ||
      endDate(date, 1) !== date
    )
      throw new Error('Укажите корректные даты периода.');
  });
  if (form.to < form.from)
    throw new Error('Дата окончания не может быть раньше даты начала.');
  const limit = Number(form.limit);
  if (!Number.isInteger(limit) || limit < 1 || limit > 1000000)
    throw new Error('Лимит публикаций: целое число от 1 до 1 000 000.');
  const amount = String(form.amount).trim().replace(',', '.');
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(amount))
    throw new Error(
      'Укажите сумму в рублях, например 490 или 490,50. Для бесплатного размещения — 0.'
    );
  const [rubles, kopecks = ''] = amount.split('.');
  const minor = Number(rubles) * 100 + Number(kopecks.padEnd(2, '0'));
  if (minor > 100000000000)
    throw new Error('Сумма превышает допустимый размер.');
  if (minor > 0 && !validPaymentDate(form.paymentDate))
    throw new Error('Укажите корректную дату оплаты.');
  if (form.notes.length > 1000)
    throw new Error('Примечание — не более 1 000 символов.');
  return {
    group_ids: [Number(form.group)],
    kind: 'paid',
    ...(username ? { username } : {}),
    ...(id ? { telegram_user_id: Number(id) } : {}),
    date_from: form.from,
    date_to: form.to,
    timezone: 'Europe/Moscow',
    limit_messages: limit,
    paid_amount_minor: minor,
    payment_date: minor > 0 ? form.paymentDate : null,
    paid_placements: limit,
    notes: form.notes.trim(),
    reason: 'Создание платного размещения',
  };
}
